import axios from "axios";
const getZESATariffs = async () => {
  try {
    const result = await axios.get("https://a.success.africa/api/prices/zesa");

    return { success: true, data: result?.data?.prices };
  } catch (error) {
    console.log(error);
    return { success: false, data: {} };
  }
};

export default getZESATariffs;
